import { mutationOptions } from '@tanstack/react-query'
import { keys } from '../queries/keys'
import {
  clockIn,
  clockOut,
  copyPlanningWeek,
  createCollaborator,
  createCollaboratorClothing,
  createCollaboratorEquipment,
  createCollaboratorUnavailability,
  createWorkShift,
  deleteCollaborator,
  deleteCollaboratorClothing,
  deleteCollaboratorEquipment,
  deleteCollaboratorUnavailability,
  deleteWorkShift,
  exportCollaboratorUnavailabilitiesToXlsx,
  exportPlanningWorkShiftsToXlsx,
  exportWorkShiftClocksToXlsx,
  optimizePlanning,
  publishPlanningSms,
  replaceCollaboratorWorkTimes,
  updatePlanningConfig,
  updateCollaborator,
  updateCollaboratorClothing,
  updateCollaboratorEquipment,
  updateCollaboratorUnavailability,
  updateWorkShift,
} from './hr.mutations'

// ============================================================================
// Collaborators mutation options
// ============================================================================

export const createCollaboratorOptions = () =>
  mutationOptions({
    mutationFn: createCollaborator,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.collaborators.all() })
    },
  })

export const updateCollaboratorOptions = () =>
  mutationOptions({
    mutationFn: updateCollaborator,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.collaborators.all() })
    },
  })

export const deleteCollaboratorOptions = () =>
  mutationOptions({
    mutationFn: deleteCollaborator,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.collaborators.all() })
    },
  })

// ============================================================================
// Collaborator work times mutation options (batch operations)
// ============================================================================

export const replaceCollaboratorWorkTimesOptions = () =>
  mutationOptions({
    mutationFn: replaceCollaboratorWorkTimes,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.workTimes(variables.collaboratorId),
      })
      // Also invalidate the collaborator since work times are nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

// ============================================================================
// Collaborator unavailabilities mutation options
// ============================================================================

export const createCollaboratorUnavailabilityOptions = () =>
  mutationOptions({
    mutationFn: createCollaboratorUnavailability,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.unavailabilities(variables.collaboratorId),
      })
      // Also invalidate the collaborator since unavailabilities are nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

export const updateCollaboratorUnavailabilityOptions = () =>
  mutationOptions({
    mutationFn: updateCollaboratorUnavailability,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.unavailabilities(variables.collaboratorId),
      })
      // Also invalidate the collaborator since unavailabilities are nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

export const deleteCollaboratorUnavailabilityOptions = () =>
  mutationOptions({
    mutationFn: deleteCollaboratorUnavailability,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.unavailabilities(variables.collaboratorId),
      })
      // Also invalidate the collaborator since unavailabilities are nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

// ============================================================================
// Collaborator equipment mutation options
// ============================================================================

export const createCollaboratorEquipmentOptions = () =>
  mutationOptions({
    mutationFn: createCollaboratorEquipment,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.equipment(variables.collaboratorId),
      })
      // Also invalidate the collaborator since equipment is nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

export const updateCollaboratorEquipmentOptions = () =>
  mutationOptions({
    mutationFn: updateCollaboratorEquipment,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.equipment(variables.collaboratorId),
      })
      // Also invalidate the collaborator since equipment is nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

export const deleteCollaboratorEquipmentOptions = () =>
  mutationOptions({
    mutationFn: deleteCollaboratorEquipment,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.equipment(variables.collaboratorId),
      })
      // Also invalidate the collaborator since equipment is nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

// ============================================================================
// Collaborator clothing mutation options
// ============================================================================

export const createCollaboratorClothingOptions = () =>
  mutationOptions({
    mutationFn: createCollaboratorClothing,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.clothing(variables.collaboratorId),
      })
      // Also invalidate the collaborator since clothing is nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

export const updateCollaboratorClothingOptions = () =>
  mutationOptions({
    mutationFn: updateCollaboratorClothing,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.clothing(variables.collaboratorId),
      })
      // Also invalidate the collaborator since clothing is nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

export const deleteCollaboratorClothingOptions = () =>
  mutationOptions({
    mutationFn: deleteCollaboratorClothing,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.clothing(variables.collaboratorId),
      })
      // Also invalidate the collaborator since clothing is nested
      context.client.invalidateQueries({
        queryKey: keys.hr.collaborators.byId(variables.collaboratorId),
      })
    },
  })

// ============================================================================
// Work shifts mutation options
// ============================================================================

export const createWorkShiftOptions = () =>
  mutationOptions({
    mutationFn: createWorkShift,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.workShifts.all() })
    },
  })

export const updateWorkShiftOptions = () =>
  mutationOptions({
    mutationFn: updateWorkShift,
    onSettled: (_data, _error, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.workShifts.all() })
    },
  })

export const deleteWorkShiftOptions = () =>
  mutationOptions({
    mutationFn: deleteWorkShift,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.workShifts.all() })
    },
  })

// ============================================================================
// Attendance mutation options
// ============================================================================

export const clockInOptions = () =>
  mutationOptions({
    mutationFn: clockIn,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.workShifts.all() })
      context.client.invalidateQueries({ queryKey: keys.hr.attendanceHistory.all() })
    },
  })

export const clockOutOptions = () =>
  mutationOptions({
    mutationFn: clockOut,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.workShifts.all() })
      context.client.invalidateQueries({ queryKey: keys.hr.attendanceHistory.all() })
    },
  })

export const exportWorkShiftClocksToXlsxOptions = () =>
  mutationOptions({
    mutationFn: exportWorkShiftClocksToXlsx,
  })

export const exportCollaboratorUnavailabilitiesToXlsxOptions = () =>
  mutationOptions({
    mutationFn: exportCollaboratorUnavailabilitiesToXlsx,
  })

export const exportPlanningWorkShiftsToXlsxOptions = () =>
  mutationOptions({
    mutationFn: exportPlanningWorkShiftsToXlsx,
  })

// ============================================================================
// Planning config mutation options
// ============================================================================

export const updatePlanningConfigOptions = () =>
  mutationOptions({
    mutationFn: updatePlanningConfig,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.planningConfig.all() })
    },
  })

// ============================================================================
// Planning mutation options
// ============================================================================

export const optimizePlanningOptions = () =>
  mutationOptions({
    mutationFn: optimizePlanning,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.workShifts.all() })
    },
  })

export const copyPlanningWeekOptions = () =>
  mutationOptions({
    mutationFn: copyPlanningWeek,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.hr.workShifts.all() })
    },
  })

export const publishPlanningSmsOptions = () =>
  mutationOptions({
    mutationFn: publishPlanningSms,
  })
